import { render, staticRenderFns } from "./SignupFooter.vue?vue&type=template&id=cb3b8afe&scoped=true"
import script from "./SignupFooter.vue?vue&type=script&lang=js"
export * from "./SignupFooter.vue?vue&type=script&lang=js"
import style0 from "./SignupFooter.vue?vue&type=style&index=0&id=cb3b8afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3b8afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
